var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d5df3b80e403408fdc7679e6c20333d387a4e547"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@plaxswap"]={id:"d5df3b80e403408fdc7679e6c20333d387a4e547"};
      